"use strict";

export default {
    id: 0,
    account: {},
    address: {},
    isFetchingAccount: false,
    isFindingEmail: false,
    isUpdatingEmail: false,
    isUpdatingPassword: false,
    isUpdatingAddress: false,
};
